import React, { PureComponent } from "react";
import Link from "next/link";

import ProfilePic from "../profile-pic/profile-pic";
import Cta from "../cta/cta";
import Tag from "../tag/tag";
import PremiumBadge from "../premium-badge/premium-badge";

import "./user-tile-promo.scss";

class UserTilePromo extends PureComponent {
  render() {
    const {
      isAlreadyPremium,
      profilePic,
      firstName,
      hasSkills,
      togglePremiumCofounder,
    } = this.props;

    return (
      <>
        {!isAlreadyPremium && (
          <div className="user-tile-promo">
            <div className="user-tile-promo__inner">
              <div className="user-tile-promo__content">
                <>
                  <div className="user-tile__details">
                    <ProfilePic
                      href={"/profile"}
                      hrefAs={`/profile`}
                      profilePic={profilePic}
                      knowledgePointsSize="MEDIUM"
                      firstName={firstName}
                      width={70}
                      height={70}
                    />
                    <div className="user-tile__indent">
                      <div className="user-tile__first-name">
                        <Link href="/profile" as={`/profile`}>
                          <a className="user-tile__first-name__link">
                            {firstName}
                          </a>
                        </Link>
                        <PremiumBadge
                          copy="Pro user"
                          showUpgradeHoverMessage={false}
                        />
                      </div>
                      <div className="user-tile__tags">
                        {hasSkills.map((skill) => {
                          return <Tag key={skill.id}
                            label={skill.label}
                            title={skill.label}
                          />;
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="user-tile-promo__copy">
                    {hasSkills.length > 0 ? (
                      <>
                        {"Get featured here for "}
                        {hasSkills.map((skill, idx) => {
                          return idx > 0 ? (
                            <span key={skill.id}>
                              <span>{` and `}</span>
                              <span className="user-tile-promo__highlight">
                                {skill.label}
                              </span>
                            </span>
                          ) : (
                            <span
                              className="user-tile-promo__highlight"
                              key={skill.id}
                            >
                              {skill.label}
                            </span>
                          );
                        })}
                        {" searches"}
                        {" and get more profile views"}
                      </>
                    ) : (
                      "Feature here to get more profile views"
                    )}
                  </div>
                  <div className="user-tile__toggle">
                    <div className="user-tile__toggle__inner">
                      <Cta
                        tag="button"
                        text="Boost profile"
                        icon="plus"
                        modifierClass="premium"
                        onClick={togglePremiumCofounder}
                      />
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default UserTilePromo;
